import React, { Component } from 'react'
import styled from 'styled-components'
import { Table, Input, Button, Icon } from 'antd'
import Highlighter from 'react-highlight-words'
import firebase from '../utils/firebaseConnect'
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  width: 100%;
`
const BoxTable = styled.div`
  width: 100%;
`
class PageAdmin extends Component {
  state = {
    searchText: '',
    data: []
  }
  componentDidMount() {
    document.title = 'จัดการข้อมูล'
    firebase
      .firestore()
      .collection('register')
      .get()
      .then(querySnapshot => {
        let getDataArray = []
        querySnapshot.forEach(function(doc) {
          getDataArray.push(doc.data())
        })
        return getDataArray
      })
      .then(arr => {
        this.setState({
          data: arr.map((data, idx) => {
            return { ...data, key: idx + 1 }
          })
        })
      })
  }
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select())
      }
    },
    render: text => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    )
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm()
    this.setState({ searchText: selectedKeys[0] })
  }

  handleReset = clearFilters => {
    clearFilters()
    this.setState({ searchText: '' })
  }
  render() {
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: '30%',
        ...this.getColumnSearchProps('name')
      },
      {
        title: 'LastName',
        dataIndex: 'lastName',
        key: 'lastName',
        width: '30%',
        ...this.getColumnSearchProps('lastName')
      },
      {
        title: 'Age',
        dataIndex: 'age',
        key: 'age',
        width: '20%',
        ...this.getColumnSearchProps('age')
      },
      {
        title: 'Gender',
        dataIndex: 'gender',
        key: 'gender',
        width: '20%',
        ...this.getColumnSearchProps('gender')
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        width: '20%',
        ...this.getColumnSearchProps('email')
      },
      {
        title: 'Telephone',
        dataIndex: 'telephone',
        key: 'telephone',
        width: '20%',
        ...this.getColumnSearchProps('telephone')
      },
      {
        title: 'LineId',
        dataIndex: 'lineId',
        key: 'lineId',
        width: '20%',
        ...this.getColumnSearchProps('lineId')
      },
      {
        title: 'Shop',
        dataIndex: 'shop',
        key: 'shop',
        ...this.getColumnSearchProps('shop')
      }
    ]
    const { data } = this.state
    return (
      <Container>
        <BoxTable>
          <Table columns={columns} dataSource={data} />
        </BoxTable>
      </Container>
    )
  }
}

export default PageAdmin
